import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../Styles/Navbar.css";
import PravartanLogo from "../assets/logo.jpg"
import { useNavigate } from "react-router-dom";


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={PravartanLogo} alt="Pravartan Logo" height={60}/>
        <h2>Pravartan</h2>
      </div>

      <div className="hamburger" onClick={() => setIsOpen(!isOpen)}>
        ☰
      </div>

      <ul className={`nav-links ${isOpen ? "open" : ""}`}>
        <li><Link to="/" onClick={() => setIsOpen(false)}>Home</Link></li>
                {/* <li><Link to="/podcast" onClick={() => setIsOpen(false)}>Podcast</Link></li> */}
        {/* <li><Link to="/events" onClick={() => setIsOpen(false)}>Events</Link></li> */}
        {/* <li><Link to="/causes" onClick={() => setIsOpen(false)}>Causes</Link></li> */}
        <li><Link to="/blog" onClick={() => setIsOpen(false)}>Blog</Link></li>
        {/* <li><Link to="/our-team" onClick={() => setIsOpen(false)}>Our Team</Link></li> */}
                {/* <li><Link to="/about-us" onClick={() => setIsOpen(false)}>About Us</Link></li> */}
                {/* <li><Link to="/testimonials" onClick={() => setIsOpen(false)}>Testimonials</Link></li> */}

      </ul>

<button 
            className="donate-btn" 
            onClick={() => navigate("/payment")}
          >Donate</button>   
           </nav>
  );
};

export default Navbar;
